import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { HardHat } from "lucide-react";

export default function PpeChecklist({ ppe, togglePpe, readOnly, missingCount }) {
  return (
    <div>
      <Label className="text-xs uppercase tracking-wider font-semibold text-gray-700 flex items-center gap-2"><HardHat className="w-3.5 h-3.5" />Personal Protective Equipment</Label>
      <div className="mt-2 grid grid-cols-2 md:grid-cols-3 gap-2" data-testid="ppe-list">
        {ppe.map((p, i) => (
          <label key={p._key || p.item || `ppe-${i}`} className={`flex items-center gap-2 border p-2 cursor-pointer transition-colors ${p.checked ? "bg-[#F0FDF4] border-[#6EE7B7]" : "bg-white border-gray-200 hover:bg-gray-50"}`}>
            <Checkbox disabled={readOnly} data-testid={`ppe-${i}`} checked={p.checked} onCheckedChange={v => togglePpe(i, !!v)} />
            <span className="text-sm">{p.item}</span>
          </label>
        ))}
      </div>
      {missingCount > 0 && <p className="text-xs text-[#92400E] mt-1">{missingCount} PPE item(s) unchecked.</p>}
    </div>
  );
}
